import { render, staticRenderFns } from "./reportStatistics.vue?vue&type=template&id=21a52cd9&scoped=true&"
import script from "./reportStatistics.vue?vue&type=script&lang=js&"
export * from "./reportStatistics.vue?vue&type=script&lang=js&"
import style0 from "./reportStatistics.vue?vue&type=style&index=0&id=21a52cd9&prod&lang=css&"
import style1 from "./reportStatistics.vue?vue&type=style&index=1&id=21a52cd9&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a52cd9",
  null
  
)

export default component.exports